<template>
  <div>
    <w-syslog-rule-table ref="syslogRuleTable" :selected-node="selectedNode"></w-syslog-rule-table>
  </div>
</template>

<script>
import WSyslogRuleTable from './components/SyslogRuleTable';

export default {
  name: 'WSyslogRule',
  components: {
    WSyslogRuleTable,
  },
  props: {
    selectedNode: Object,
  },
  data() {
    return {
      selectedObj: {},
    };
  },
  methods: {
    targetChange(data) {
      this.selectedObj = data;
    },
    loadData() {
      this.$refs.syslogRuleTable.loadData();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Syslog/SyslogRule.vue